<template>
    <div>
        <div class="form-horizontal" enctype="multipart/form-data" @submit.prevent="store" @keydown="form.errors.clear($event.target.name)">
            <table class="table table-striped">
                <tr>
                    <th>{{ uLang('app.name') }}</th>
                    <th>{{ uLang('app.action') }}</th>
                </tr>
                <tr v-for="category in categories">
                    <td>
                        <input type="text" class="form-control" :name="category.value" v-model="form['value'][category.id]">
                    </td>
                    <td>
                        <a href="#" v-show="category.deleteable == 1" @click.prevent="removeCategories(category)" class="btn btn-danger">
                            <i class="fa fa-trash"></i>
                        </a>
                    </td>
                </tr>
            </table>

            <div class="form-group">
                <div class="input-group">
                    <input type="text" class="form-control" name="new" v-model="newCategory" :placeholder="uLang('app.add_new_log_category')">
                    <span class="input-group-btn">
                        <button type="button" class="btn btn-success" @click="addCategory" :disabled="form.busy || !newCategory">{{ uLang('app.add_new_log_category') }}</button>
                    </span>
                </div>
            </div>

            <div class="form-group">
                <input :disabled="form.busy" type="button" :value="uLang('app.save_setting')" @click="store()" class="btn btn-brand" />
            </div>
        </div>
    </div>
</template>

<script>
    import Form from '~/Form/Form'
    import { ErrorAlert, SuccessAlert, DestroyAlert } from '~/Swals'

    export default {
        name: 'LogCategories',
        props: {
            settingId: {
                required: true,
            },
        },
        data() {
            return {
                form: new Form({
                    value: {},
                }),
                newCategory: '',
                categories: [],
            }
        },

        mounted() {
            this.retrieveCategories()
        },

        methods: {
            async store() {
                this.form['patch']('/api/admin/settings/' + this.settingId)
                    .then(response => {
                        this.setValues(response);
                        new SuccessAlert({ text: this.uLang('app.type_successfully_updated', {type: lang('app.log_categories')})}).show();
                    })
                    .catch(error => {
                        new ErrorAlert({
                            title: uLang('app.oops_something_went_wrong'),
                            text: uLang('app.all_inputs_need_to_be_filled'),
                        }).show();
                    });
            },

            addCategory() {
                if (this.newCategory === '')
                    return;

                this.categories.push(
                    {
                        id: this.newCategory,
                        value: this.newCategory,
                        deleteable: 1,
                        editable: 1
                    }
                );
                this.form.value[this.newCategory] = this.newCategory;
                this.newCategory = '';
            },

            setValues(data) {
                this.categories = data;
                data.forEach(function (category){
                    this.value[category.id] = category.value;
                }, this.form);
            },

            async retrieveCategories() {
                const { data } = await window.axios.get(route('logs.categories.index'));
                this.setValues(data);
            },

            removeCategories(category) {
                new DestroyAlert({ entity: this.lang('app.log_category') }).show().then(async () => {
                    delete this.form.value[category.id];

                    //remove the category from the table
                    this.categories = this.categories.filter(function (current_category) {
                        return current_category.value != category.value;
                    });
                })
            }
        }
    }
</script>

<style lang="css" scoped>

</style>